import {useQuery, keepPreviousData} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config";
import {ApiHookProps} from '@/@types/api.types';
import {MyBalanceDto} from '@/features/account/types/account-dto';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {} & ApiHookProps;

export const useAccountBalanceApi = ({}: Props = {}) => {
    const axiosInstance = useAxiosAuth();

    const {
        data: accountBalanceData,
        isLoading: isLoadingAccountBalanceData,
        isError: isErrorAccountBalanceData,
    } = useQuery({
        queryKey: [ApiConfig.queries.features.accounts.queryKeys.balance],
        queryFn: async (): Promise<MyBalanceDto> => {
            const url = ApiConfig.queries.features.accounts.endpoints.balance;
            const response = await axiosInstance.get<MyBalanceDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData
    });

    return {
        accountBalanceData,
        isLoadingAccountBalanceData,
        isErrorAccountBalanceData,
    }
};
